import React, { createRef } from "react";
import { Route } from "react-router-dom";
import Media from "react-media";
import { Subscription } from 'rxjs'
import './HomePage.scss'
import { Button } from "@material-ui/core";
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../components/header/mobile/HeaderMobile";
import { ReactComponent as Arrow } from "../../resources/images/arrow.svg";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { ConfigProvider } from "../../services/configuration/ConfigProvider";
import StateContextProvider from "../../context/StateContext";
import { MposWebPortalApi } from '../../services/api/MposWebPortalApi';
import { ReactComponent as CertificateIcon } from '../../resources/images/certified-file.svg';


export class HomePage extends React.Component<any, any> {
  private config = ConfigProvider.getInstance().getConfiguration();
  private getTerminalsSubscription: Subscription | null = null;
  scope: any;
  userLogin: any;
  // certificate: boolean;
  fileInputRef = createRef<HTMLInputElement>();

  constructor(props: any) {
    super(props);

    this.showTerminals = this.showTerminals.bind(this);
    this.showUsers = this.showUsers.bind(this);
    this.goToHelp = this.goToHelp.bind(this);
    // this.certificate = StateContextProvider.getInstance().getProp("certificate");
    this.scope = StateContextProvider.getInstance().getProp("scope");
    this.state = {
      certificate: StateContextProvider.getInstance().getProp("certificate"),
      certificateResponse: null,
      certificateError: null,
      file: null,
      selectedFile: null,
    };
  }

  componentDidMount() {
    GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, 'Home', {});

    this.userLogin = MposWebPortalApi.getInstance().userLogin().subscribe((payload: any) => {
      StateContextProvider.getInstance().setProp('certificate', payload.certificate);
      this.setState({ certificate: payload.certificate })
    }, () => { });
  }

  private static renderDesktopHeader(): JSX.Element {
    return (
      <HeaderDesktop showBack={false} showLogout={true} showTitle={false} selectedElement={0} title={"Home"} />
    );
  }

  private static renderMobileHeader(): JSX.Element {
    return (
      <HeaderMobile showBack={false} showLogout={true} showTitle={true} title={"Home"} />
    );
  }

  private showTerminals(history: any) {
    console.log("[HomePage][showTerminals] go to terminal page!")
    history.push('/terminals');
  }

  private showUsers(history: any) {
    console.log("[HomePage][showUsers] go to users page!")
    history.push('/users');
  }

  private showCatalog(history: any) {
    console.log("[HomePage][showUsers] go to users page!")
    history.push('/catalog');
  }

  private showApplications(history: any) {
    console.log("[HomePage][showApplications] go to applications page!")
    history.push('/applications');
  }

  private showMerchants(history: any) {
    console.log("[HomePage][showMerchants] go to merchants page!")
    history.push('/merchants');
  }

  private goToHelp() {
    GoogleTagManagerService.getInstance().pushInteractionEvent('Click', 'home', 'click', 'assistenza hai bisogno di aiuto');
    console.log("[HomePage][goToHelp] go to help page!");
    // @ts-ignore
    window.location = this.config.supportLink;
  }

  private manageTermsAndConditions(history: any) {
    GoogleTagManagerService.getInstance().pushInteractionEvent('Click', 'footer', 'click', 'termini e condizioni');
    console.log("[Footer][goToTermsAndConditions] go to T&C page!")
    history.push('/termsAndConditions', { fromHome: true });
  }

  private openFile() {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  }

  private handleSelectedFileAndChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    this.setState({
      certificateError: null,
      file: file
    })

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (typeof reader.result === 'string') {
          const base64 = reader.result.split(',')[1];
          this.setState({ selectedFile: base64 });
        } else {
          console.error('Errore: il risultato del lettore non è una stringa');
        }
      };
      reader.readAsDataURL(file);
    }
  };

  private sendTheFile() {
    const payload = {
      certificate: this.state.selectedFile
    }

    MposWebPortalApi
      .getInstance()
      .uploadCertificate(payload)
      .subscribe((response: any) => {
        StateContextProvider.getInstance().setProp("certificate", true)
        this.setState({
          certificate: true,
          certificateError: null,
          certificateResponse: response,
        })
      }, (error) => {
        this.setState({
          certificateError: error,
          selectedFile: null,
        })
        this.resetFileInput();
      });
  };

  private resetFileInput = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
  };

  private handleDelete() {
    this.setState({ selectedFile: null });
    this.resetFileInput();
  };

  renderHome(): JSX.Element {
    return (
      <div id={"main-container-home"}>
        <Media query="(max-width: 1064px)" render={() => HomePage.renderMobileHeader()} />
        <Media query="(min-width: 1065px)" render={() => HomePage.renderDesktopHeader()} />
        <div className={"home-container-content"}>
          <div className={"home-button-container"}>
            {this.scope === 'MPOS_admin' ? (
              <>
                <Route render={({ history }) => {
                  return <Button id={"home-button-catalog"} className="home-tile" onClick={() => this.showCatalog(history)}>
                    <div className={"home-button-content"}>
                      <div className={"home-button-text"}>
                        <div className={"home-badge-and-title-container"}>
                          <p className={"home-button-title"}>Il tuo catalogo prodotti</p>
                          <div className={"home-badge-element-main-style"} style={{ backgroundColor: '#48D597' }}>
                            <p className={"home-badge-element-text"}>{"Novità".toUpperCase()}</p>
                          </div>
                        </div>
                        <p className={"home-button-subtitle"}>
                          Crea e gestisci i prodotti dei tuoi cataloghi e assegna al tuo staff  il catalogo più adatto al loro lavoro.
                        </p>
                      </div>
                      <div className={"home-button-icon"}>
                        <Arrow className={"home-badge-arrow-icon"} />
                      </div>
                    </div>
                  </Button>
                }} />
                <Route render={({ history }) => {
                  return <Button id={"home-button-terminals"} className="home-tile" onClick={() => this.showTerminals(history)}>
                    <div className={"home-button-content"}>
                      <div className={"home-button-text"}>
                        <div className={"home-badge-and-title-container"}>
                          <p className={"home-button-title"}>I tuoi terminali</p>
                        </div>
                        <p className={"home-button-subtitle"}>
                          Visualizza l’elenco degli ID Terminale disponibili per la tua attività e a chi sono associati.
                        </p>
                      </div>
                      <div className={"home-button-icon"}>
                        <Arrow className={"home-arrow-icon"} />
                      </div>
                    </div>
                  </Button>
                }} />
                <Route render={({ history }) => {
                  return <Button id={"home-button-users"} className="home-tile" onClick={() => { this.showUsers(history) }}>
                    <div className={"home-button-content"}>
                      <div className={"home-button-text"}>
                        <div className={"home-badge-and-title-container"}>
                          <p className={"home-button-title"}>Le tue utenze</p>
                        </div>
                        <p className={"home-button-subtitle"}>
                          Crea e gestisci gli account del tuo staff e assegna un ID Terminale per renderli operativi.
                        </p>
                      </div>
                      <div className={"home-button-icon"}>
                        <Arrow className={"home-arrow-icon"} />
                      </div>
                    </div>
                  </Button>
                }} />
              </>
            ) : null}
            {this.scope === 'MPOS_DEVELOPER' ? (
              <>
                <Route render={({ history }) => {
                  return <Button id={"home-button-users"} className="home-tile" onClick={() => { this.showApplications(history) }}>
                    <div className={"home-button-content"}>
                      <div className={"home-button-text"}>
                        <div className={"home-badge-and-title-container"}>
                          <p className={"home-button-title"}>Le tue applicazioni</p>
                        </div>
                        <p className={"home-button-subtitle"}>
                          Visualizza l'elenco delle tue applicazioni disponibili per la tua attività e a quali Merchants sono associate.
                        </p>
                      </div>
                      <div className={"home-button-icon"}>
                        <Arrow className={"home-arrow-icon"} />
                      </div>
                    </div>
                  </Button>
                }} />
                <Route render={({ history }) => {
                  return <Button id={"home-button-users"} className="home-tile" onClick={() => { this.showMerchants(history) }}>
                    <div className={"home-button-content"}>
                      <div className={"home-button-text"}>
                        <div className={"home-badge-and-title-container"}>
                          <p className={"home-button-title"}>I tuoi punti vendita</p>
                        </div>
                        <p className={"home-button-subtitle"}>
                          Visualizza l'elenco dei punti vendita associati al tuo account.
                        </p>
                      </div>
                      <div className={"home-button-icon"}>
                        <Arrow className={"home-arrow-icon"} />
                      </div>
                    </div>
                  </Button>
                }} />
              </>
            ) : null}
          </div>
          {this.scope === 'MPOS_DEVELOPER' ? (
            <div className="home-certificate-container">
              <div className="home-certificate-header">
                <input
                  type="file"
                  ref={this.fileInputRef}
                  style={{ display: 'none' }}
                  onChange={this.handleSelectedFileAndChange}
                  accept=".csr"
                />
                <p className="application-type-title">CERTIFICATO</p>
                {!this.state.certificate ? (
                  <Button
                    className="user-terms-and-conditions"
                    type={"button"}
                    disabled={this.state.selectedFile !== null}
                    onClick={() => this.openFile()}
                  >
                    CARICA CERTIFICATO
                  </Button>
                ) : null}
              </div>
              <div className="home-certificate-content">
                {this.state.certificate ? (
                  <>
                    <CertificateIcon />
                    <p className="not-certificate">Certificato caricato</p>
                  </>
                ) : (
                  this.state?.certificateError !== null ? (
                    <p className="not-certificate">
                      {this.state.certificateError.data.message}
                    </p>
                  ) : (
                    <>
                      {this.state.selectedFile ? (
                        <div className="box-certificate">
                          <div className="infoFile">
                            <CertificateIcon />
                            <p className="certificate-name">{this.state.file.name}</p>
                          </div>
                          <div className="boxCta">
                            <Button className="cta" onClick={() => this.sendTheFile()}>
                              Invia
                            </Button>
                            <div className="border"></div>
                            <Button className="cta" onClick={() => this.handleDelete()}>
                              Elimina
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <p className="not-certificate">Nessun certificato caricato</p>
                      )}
                    </>
                  )
                )}
              </div>
            </div>
          ) : null}
        </div>
        {this.scope === 'MPOS_admin' ? (
          <div className="home-container-footer">
            <div className="home-anchor-container">
              <Route render={({ history }) => {
                return <Button
                  className="user-terms-and-conditions"
                  type={"button"}
                  onClick={() => {
                    this.manageTermsAndConditions(history);
                    return false;
                  }}
                >
                  TERMINI E CONDIZIONI
                </Button>
              }} />
            </div>
            <div className={"home-box-help"}>
              <p className={"home-help-title"}>Hai bisogno di aiuto?</p>
              <p className={"home-help-subtitle"}>Per maggiori informazioni sull’App Nexi POS consulta le domande più frequenti oppure contatta il Servizio Clienti.</p>
              <Route render={({ history }) => {
                return <Button id={"home-help-button"} disableRipple={true} onClick={() => this.goToHelp()}>VAI</Button>
              }} />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    return this.renderHome();
  }
}
